import { action } from 'typesafe-actions'
import { ADD_PD_CONVERSATIONS } from '../constants/action-types'
import { HelpScoutConversationType } from '../store/lookup/helpscout'

export const addHelpscoutConversations = (
  payload: HelpScoutConversationType[]
) => action(ADD_PD_CONVERSATIONS, payload)
